/* eslint-disable no-unused-vars */
import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import {
  firebaseConnect,
  isLoaded,
  isEmpty
} from 'react-redux-firebase'
import {  Container, Table, Header, Popup, Rating, Icon, Loader, List  } from 'semantic-ui-react'

import { isAdmin } from './helpers';

class LocationsList extends Component {

  state = {
    column: 'date',
    data: [],
    direction: 'descending',
    loading: true,
  }

  componentDidUpdate(prevProps, prevState) {
    const { sessions } = this.props
    // set user data from firebase
    if(isLoaded(sessions) && this.state.data.length === 0 && this.state.loading) {
      // // Initialize Data after filtering out entries without a username
      // let filteredUsers = _.map(users, (u, key) => { return {...u, userId: key} } ); // retain key
      // this.initialSort(_.pickBy(filteredUsers, u => u.username) );

      let locations = _.countBy(sessions, 'locale')


      // turn it into array
      let data = _.map(locations, (count, location) => {
        return { count, name: location }
      });
      this.setState({data, loading: false})

    }
  }

  handleSort = clickedColumn => () => {
    const { column, data, direction } = this.state

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: _.sortBy(data, [clickedColumn]),
        direction: 'ascending',
      })

      return
    }

    this.setState({
      data: data.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  render() {
    if(!isAdmin(this.props.auth))
      return null

    const { column, data, direction, loading  } = this.state

    if(loading)
      return <Loader active />

    return (
      <Container>

        <Header as='h2'>Locations ({data.length})</Header>

        <Table sortable celled >
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell
                width={3}
                sorted={column === 'name' ? direction : null}
                onClick={this.handleSort('name')}
              >
                Location
              </Table.HeaderCell>
              <Table.HeaderCell
              width={3}
                sorted={column === 'count' ? direction : null}
                onClick={this.handleSort('count')}
              >
                Sessions
              </Table.HeaderCell>

            </Table.Row>
          </Table.Header>
          <Table.Body>
            {_.map(data, (location) => (
              <Table.Row key={Math.random()}>
                <Table.Cell><Header as='h5' textAlign='left'>{location.name}</Header></Table.Cell>
                <Table.Cell>{location.count}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>

      </Container>
    )
  }
}

export default compose(
  firebaseConnect([
    'geoFire'
  ]),
  connect((state) => ({
    sessions: state.firebase.data.geoFire,
    auth: state.firebase.auth,
  }))
)(LocationsList)



// WEBPACK FOOTER //
// ./src/components/pages/admin/LocationsList.js